
import AdminListComponent from "../../../components/admins/Index.vue";

export default {
  components: {
    AdminListComponent,
  },
};
